<template>
    <div class="product-status-cell" :title="title">
        <span
            v-if="!meta.isEmpty"
            class="product-status-dot"
            :class="'product-status-dot--' + meta.color"
        ></span>
    </div>
</template>

<script>
export default {
    name: 'ProductOverviewStatusDot',
    props: {
        meta: {
            type: Object,
            required: true,
        }
    },
    computed: {
        title() {
            return this.meta.titleKey ? this.$t(this.meta.titleKey) : '';
        }
    }
}
</script>

<style scoped>
.product-status-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 24px;
}
.product-status-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
}
.product-status-dot--gray {
    background-color: #adb5bd;
}
.product-status-dot--green {
    background-color: #28a745;
}
.product-status-dot--red {
    background-color: #dc3545;
}
.product-status-dot--yellow {
    background-color: #ffc107;
}
</style>
